module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cta":"","next":"","otherArticles":""},"en":{"cta":"Get offer","next":"Read next","otherArticles":"Other articles"},"it":{"cta":"Richiedi la tua valutazione","next":"","otherArticles":"Altri articoli"},"lt":{"cta":"","next":"Kitas įrašas","otherArticles":""},"pl":{"cta":"","next":"Czytaj następny","otherArticles":""}}')
  delete Component.options._Ctor
}
